// extracted by mini-css-extract-plugin
export var questionsAndAnswers = "csb-transition-module--questionsAndAnswers--ot1pb";